import { DAYS_OF_WEEK, type Hours } from "../../../lib/catalog";

export function summarizeHours(h: Hours | Record<string, { open: string; close: string; closed: boolean }>): string {
  const groups: Array<{ days: string[]; open: string; close: string; closed: boolean }> = [];
  for (const d of DAYS_OF_WEEK) {
    // Scratch uses mon/tue; PBF preserves Google's full weekday names.
    const cur = h[d.id] ?? h[d.label.toLowerCase()];
    if (!cur) continue;
    const last = groups[groups.length - 1];
    if (last && last.closed === cur.closed && last.open === cur.open && last.close === cur.close) {
      last.days.push(d.label);
    } else {
      groups.push({ days: [d.label], open: cur.open, close: cur.close, closed: cur.closed });
    }
  }
  return groups.map((g) => {
    const range = g.days.length === 1
      ? g.days[0].slice(0, 3)
      : `${g.days[0].slice(0, 3)}–${g.days[g.days.length - 1].slice(0, 3)}`;
    return g.closed ? `${range} closed` : `${range} ${g.open}–${g.close}`;
  }).join(" · ");
}
